<template>
  <div>
    <cms-buttons
      v-if="buttonsSetUp"
      :theme="buttonsOptions"
      :content="homepage.buttons[id]"
      :logo="watermarkLogo"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { isEmpty } from 'lodash';

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const store = useStore();

const theme = computed(() => store.state.theme);
const homepage = computed(() => store.state.homepage);
const isThemePreview = computed(() => store.state.isThemePreview);
const globals = computed(() => store.state.globals);

const id = computed(() => {
  if (isThemePreview.value) {
    return 'preview_id';
  }
  return `${props.containerId}_${props.componentIdx}`;
});

const buttonsOptions = computed(() => {
  if (!theme.value?.containers) return {};
  return {
    ...theme.value.containers[props.containerIdx].components[props.componentIdx].options,
    translations: store.getters['translation/getComponentTranslation']('buttons'),
    globalThemeSettings: store.getters.getGlobalThemeSettings,
  };
});

const buttonsSetUp = computed(() => !isEmpty(homepage.value?.buttons?.[id.value]?.content));

const watermarkLogo = computed(() => globals.value.watermark?.url || globals.value.logo.url);
</script>
